import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream-100 px-6 pb-10 sm:pb-12" aria-labelledby="faq-title" data-id="element-55" data-mp="1blka2yumh30n">
      <div className="mx-auto max-w-3xl" data-id="element-56" data-mp="1gitxya2d56md">
        <h2 id="faq-title" className="text-center font-display text-3xl font-bold uppercase tracking-tight text-forest-800 sm:text-4xl" data-id="element-57" data-mp="1glpt5qmtth74">
          Frequently Asked Questions
        </h2>

        <ul className="mt-5 grid gap-2.5" data-id="element-58" data-mp="28cmab3fx6807">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const isOpen = openIndex === index;
          return <li key={question} className="overflow-hidden rounded-xl border border-cream-300/60 bg-white" data-id="element-59" data-mp="1zgmzb7xc98hn" data-mpi={index}>
                <h3 data-id="element-60" data-mp="2n5z4lwpjoweo">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-5 py-4 text-left font-semibold text-forest-800 transition-colors duration-150 ease-out hover:text-ember-500" data-id="element-61" data-mp="2rysbaq4kqete">
                    {question}
                    {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-ember-500" aria-hidden="true" data-id="element-62" data-mp="19tlla7f115k2" /> : <PlusIcon className="h-4 w-4 shrink-0 text-forest-400" aria-hidden="true" data-id="element-63" data-mp="1ole08iawshl9" />}
                  </button>
                </h3>
                <div className={`grid transition-[grid-template-rows] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-64" data-mp="1xiwl9mojyvx5">
                  <div className="overflow-hidden" data-id="element-65" data-mp="366u3cpkk0tg">
                    <p className="px-5 pb-5 text-[0.95rem] leading-relaxed text-forest-600/90" data-id="element-66" data-mp="3ucreidl4cahi">{answer}</p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}